import en from './en'
import br from './br'
import nl from './nl'
import zh from './zh'
import ko from './ko'

const locales = [
  'en',
  'br',
  'nl',
  'zh',
  'ko'
]
const messages = {
  en,
  br,  
  nl,
  zh,
  ko
}

export default {
  locales,
  messages,
}



// WEBPACK FOOTER //
// ./src/locales/index.js